import { ISiteNetworkOption } from 'types/siteNetwork.interface'
import { tokens } from 'styling/tokens'

export const vehicleOptions: ISiteNetworkOption[] = [
  { label: 'Haul truck · loaded', value: 'HAUL_TRUCK|LOADED' },
  { label: 'Haul truck · empty', value: 'HAUL_TRUCK|EMPTY' },
  { label: 'Light vehicle', value: 'LV|NA' },
  { label: 'Crew bus', value: 'BUS|NA' },
  { label: 'On foot', value: 'PERSON|NA' },
]

export const roadClassOptions: ISiteNetworkOption[] = [
  { label: 'Haul primary', value: 'HAUL_PRIMARY' },
  { label: 'Haul ramp', value: 'HAUL_RAMP' },
  { label: 'Bench access', value: 'BENCH_ACCESS' },
  { label: 'Service road', value: 'SERVICE_ROAD' },
  { label: 'LV only', value: 'LIGHT_VEHICLE_ONLY' },
  { label: 'Pedestrian', value: 'PEDESTRIAN' },
]

export const roadEventTypeOptions: ISiteNetworkOption[] = [
  { label: 'Closed', value: 'CLOSED' },
  { label: 'Restricted', value: 'RESTRICTED' },
  { label: 'Speed limit', value: 'SPEED_LIMIT' },
  { label: 'Degraded', value: 'DEGRADED' },
]

export const roadClassColors: { [key: string]: string } = {
  HAUL_PRIMARY: tokens.status.warning.fg,
  HAUL_RAMP: tokens.accent.base,
  BENCH_ACCESS: tokens.status.accent.fg,
  SERVICE_ROAD: tokens.text.secondary,
  LIGHT_VEHICLE_ONLY: tokens.status.info.fg,
  PEDESTRIAN: tokens.text.muted,
}

export const defaultRoadClassColor = tokens.text.secondary
